import validate from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.1_es_cf531f2dcd08b1b73ac12f0d8cc6bafc/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45jwt_45global from "/builds/bunuble/bunuble/bunuble/middleware/01.jwt.global.ts";
import manifest_45route_45rule from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.1_es_cf531f2dcd08b1b73ac12f0d8cc6bafc/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45jwt_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/bunuble/bunuble/bunuble/middleware/auth.ts"),
  "tmp-redirect-from-index": () => import("/builds/bunuble/bunuble/bunuble/middleware/tmp-redirect-from-index.ts")
}